/**
 * Umami Event Tracking for CrispyGreen Shopify Store
 * Tracks key ecommerce events for analytics
 */

(function() {
  'use strict';

  // Wait for Umami to be loaded
  function waitForUmami(callback) {
    if (window.umami) {
      callback();
    } else {
      setTimeout(() => waitForUmami(callback), 100);
    }
  }

  waitForUmami(function() {
    console.log('[Umami] Event tracking initialized');

    // 1. TRACK ADD TO CART
    document.addEventListener('submit', function(e) {
      const form = e.target;

      // Check if it's an add-to-cart form
      if (form.getAttribute('action') === '/cart/add') {
        const formData = new FormData(form);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;

        // Get product info from page (if available)
        const productTitle = document.querySelector('[data-product-title], .product-title, h1')?.textContent?.trim() || 'Unknown Product';
        const productPrice = document.querySelector('[data-product-price], .product-price')?.textContent?.trim() || '';

        umami.track('Add to Cart', {
          product: productTitle,
          variant_id: variantId,
          quantity: quantity,
          price: productPrice
        });

        console.log('[Umami] Tracked: Add to Cart -', productTitle);
      }
    });

    // 2. TRACK CHECKOUT BUTTON CLICKS
    document.addEventListener('click', function(e) {
      const target = e.target.closest('[name="checkout"], .checkout-button, button[type="submit"][formaction*="checkout"]');

      if (target) {
        // Try to get cart value from page
        const cartTotal = document.querySelector('.cart__total, [data-cart-total]')?.textContent?.trim() || '';
        const itemCount = document.querySelectorAll('.cart-item, [data-cart-item]').length || '';

        umami.track('Begin Checkout', {
          cart_total: cartTotal,
          item_count: itemCount
        });

        console.log('[Umami] Tracked: Begin Checkout');
      }
    });

    // 3. TRACK NEWSLETTER SIGNUP
    document.addEventListener('submit', function(e) {
      const form = e.target;

      // Check for newsletter forms (common selectors)
      if (form.classList.contains('newsletter-form') ||
          form.querySelector('input[name="contact[tags]"][value*="newsletter"]') ||
          form.querySelector('input[type="email"][name*="newsletter"]')) {

        const email = form.querySelector('input[type="email"]')?.value || '';
        const location = form.closest('[data-section-id]')?.dataset.sectionId || 'unknown';

        umami.track('Newsletter Signup', {
          location: location,
          has_email: email ? 'yes' : 'no'
        });

        console.log('[Umami] Tracked: Newsletter Signup');
      }
    });

    // 4. TRACK PRODUCT QUICK VIEW
    document.addEventListener('click', function(e) {
      const quickViewBtn = e.target.closest('[data-quick-view], .quick-view-button, button[aria-label*="Quick view"]');

      if (quickViewBtn) {
        const productHandle = quickViewBtn.dataset.productHandle ||
                             quickViewBtn.dataset.product ||
                             quickViewBtn.closest('[data-product-handle]')?.dataset.productHandle ||
                             'unknown';

        umami.track('Quick View', {
          product: productHandle
        });

        console.log('[Umami] Tracked: Quick View -', productHandle);
      }
    });

    // 5. TRACK STORE LOCATOR USAGE
    // Look for store locator form submissions or search
    document.addEventListener('submit', function(e) {
      const form = e.target;

      if (form.id === 'store-locator-form' ||
          form.querySelector('input[name*="zip"], input[name*="postal"], input[name*="location"]')) {

        const searchValue = form.querySelector('input[type="text"], input[type="search"]')?.value || '';

        umami.track('Store Locator Search', {
          search_type: searchValue.match(/^\d{5}$/) ? 'zip' : 'text',
          has_value: searchValue ? 'yes' : 'no'
        });

        console.log('[Umami] Tracked: Store Locator Search');
      }
    });

    // 6. TRACK COLLECTION FILTERING
    document.addEventListener('change', function(e) {
      const filter = e.target;

      // Collection filter changes (common Shopify pattern)
      if (filter.name === 'filter.v.option.vendor' ||
          filter.name === 'filter.v.price' ||
          filter.closest('.collection-filters, .facets-wrapper')) {

        const filterType = filter.name?.split('.').pop() || filter.dataset.filterType || 'unknown';
        const filterValue = filter.value || filter.textContent?.trim() || '';

        umami.track('Collection Filter', {
          type: filterType,
          value: filterValue
        });

        console.log('[Umami] Tracked: Collection Filter -', filterType);
      }
    });

    // 7. TRACK WISHLIST ACTIONS
    document.addEventListener('click', function(e) {
      const wishlistBtn = e.target.closest('[data-wishlist], .wishlist-button, button[aria-label*="wishlist"]');

      if (wishlistBtn) {
        const action = wishlistBtn.classList.contains('active') ? 'remove' : 'add';
        const productHandle = wishlistBtn.dataset.productHandle || 'unknown';

        umami.track('Wishlist Action', {
          action: action,
          product: productHandle
        });

        console.log('[Umami] Tracked: Wishlist -', action, productHandle);
      }
    });

    // 8. TRACK SAMPLE/PROMO REQUESTS
    document.addEventListener('submit', function(e) {
      const form = e.target;

      if (form.action?.includes('sample') ||
          form.action?.includes('coupon') ||
          form.querySelector('input[name*="sample"], input[name*="coupon"]')) {

        const formType = form.action?.includes('sample') ? 'sample' : 'coupon';

        umami.track('Promo Request', {
          type: formType,
          page: window.location.pathname
        });

        console.log('[Umami] Tracked: Promo Request -', formType);
      }
    });

    // 9. TRACK PRODUCT PAGE INTERACTIONS
    if (window.location.pathname.includes('/products/')) {
      const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0] || '';

      // Track page view with product context (automatic via Umami, but adding properties)
      umami.track('Product View', {
        product: productHandle,
        referrer: document.referrer ? new URL(document.referrer).pathname : 'direct'
      });
    }

    // 10. TRACK VIDEO PLAYS (if you have product videos)
    document.addEventListener('play', function(e) {
      if (e.target.tagName === 'VIDEO') {
        const videoSrc = e.target.currentSrc || e.target.src || '';
        const videoName = videoSrc.split('/').pop()?.split('?')[0] || 'unknown';

        umami.track('Video Play', {
          video: videoName,
          page: window.location.pathname
        });

        console.log('[Umami] Tracked: Video Play -', videoName);
      }
    }, true);

  });
})();
